import { clearPersonalDetailsAutofill } from "@/shared/redux/reducers/autofillPersonalDetailsSlice";
import {
  clearQuoteFlowPolicyResult,
  clearQuoteFlowState,
  setQuoteFlowPaymentStatus,
} from "@/shared/redux/reducers/quoteFlowSlice";
import type { AppDispatch } from "@/shared/redux/store/store";

import { resetCarQuoteState } from "@/D2C/features/car-quote/redux/car-quote/carQuoteSlice";
import { resetMotorSumInsuredState } from "@/D2C/features/car-quote/redux/motor-suminsured/motorSumInsuredSlice";
import { resetHealthQuoteState } from "@/D2C/features/health-quote/redux/health-quote/healthQuoteSlice";
import { resetLifeQuoteState } from "@/D2C/features/life-quote/redux/lifeQuoteSlice";
import { resetTravelQuoteState } from "@/D2C/features/travel-quote/redux/travel-quote/travelQuoteSlice";
import { clearQuoteList } from "@/shared/redux/reducers/commonSlice";
import { clearSharedPersonalDetails } from "@/shared/redux/reducers/personalDetailsSlice";
import { clearAllQuoteAndAddonCaches } from "@/shared/redux/reducers/quoteAndAddonSlice";

export const clearJourneyDataAfterPaymentSuccess = () => (dispatch: AppDispatch) => {
  dispatch(clearPersonalDetailsAutofill());
  dispatch(clearQuoteFlowState());
  dispatch(resetTravelQuoteState());
  dispatch(resetHealthQuoteState());
  dispatch(resetCarQuoteState());
  dispatch(resetMotorSumInsuredState());
  dispatch(resetLifeQuoteState());
  dispatch(clearQuoteList());
  dispatch(clearAllQuoteAndAddonCaches());
  dispatch(clearSharedPersonalDetails());
};

export const clearJourneyDataOnInactivity = () => (dispatch: AppDispatch) => {
  dispatch(clearPersonalDetailsAutofill());
  dispatch(setQuoteFlowPaymentStatus("IDLE"));
  dispatch(clearQuoteFlowPolicyResult());
  dispatch(clearQuoteFlowState());
  dispatch(resetTravelQuoteState());
  dispatch(resetHealthQuoteState());
  dispatch(resetCarQuoteState());
  dispatch(resetMotorSumInsuredState());
  dispatch(resetLifeQuoteState());
  dispatch(clearQuoteList());
  dispatch(clearAllQuoteAndAddonCaches());
  dispatch(clearSharedPersonalDetails());
};
